import * as React from 'react';
import Slider from '@mui/material/Slider';

const marks = [
  {
    value: 0,
    label: '<1',
  },
  {
    value: 1,
    label: '1',
  },
  {
    value: 2,
    label: '2',
  },
  {
    value: 5,
    label: '5',
  },
  {
    value: 10,
    label: '10',
  },
  {
    value: 11,
    label: '>10',
  },
];

export default function ExperienceSlider({experience, setExperience}) {

    const handleChange = (event, newValue) => {
      setExperience(newValue);
    };
    return (
        <Slider
            aria-label="Custom marks"
            value={experience}
            onChange={handleChange}
            max={11}
            step={1}
            marks={marks}
            sx={{
                maxWidth: '90%',
            }}
        />
    );
}